const MAX_LOGS = 100;
const BATCH_MAX = 10;
const BATCH_INTERVAL = 4000;
const SESSION_ID = (() => {
  try {
    return sessionStorage.getItem('adminSessionId') || (() => {
      const id = 'admin_' + Math.random().toString(36).slice(2);
      sessionStorage.setItem('adminSessionId', id);
      return id;
    })();
  } catch { return 'nosession'; }
})();

let batchTimer = null;
const STATE = { logs: [], queue: [], signatureCounts: {}, signatureWindow: 60_000 };
const STORAGE_KEY = 'adminErrorLogsV1';
const REMOTE_ENDPOINT = (() => {
  const base = import.meta.env.VITE_API_BASE_URL;
  if (typeof base === 'string') return base.replace(/\/$/, '') + '/api/logs';
  return import.meta.env.PROD
    ? 'https://api.wasser-pro.com/api/logs'
    : '/api/logs';
})();

function persist() {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(STATE.logs)); } catch {}
}

export function loadPersistedErrors() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) STATE.logs = JSON.parse(raw).slice(-MAX_LOGS);
  } catch {}
}

function enqueueForRemote(entry) {
  STATE.queue.push(entry);
  if (STATE.queue.length >= BATCH_MAX) { flushQueue(); return; }
  if (!batchTimer) batchTimer = setTimeout(flushQueue, BATCH_INTERVAL);
}

async function flushQueue() {
  if (batchTimer) { clearTimeout(batchTimer); batchTimer = null; }
  if (!STATE.queue.length) return;
  const payload = { entries: STATE.queue.splice(0), sessionId: SESSION_ID, source: 'admin' };
  try {
    fetch(REMOTE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(() => {});
  } catch {}
}

function shouldSample(signature) {
  const now = Date.now();
  if (!STATE.windowStart || now - STATE.windowStart > STATE.signatureWindow) {
    STATE.windowStart = now;
    STATE.signatureCounts = {};
  }
  const count = (STATE.signatureCounts[signature] || 0) + 1;
  STATE.signatureCounts[signature] = count;
  if (count <= 5) return true;
  return count % 10 === 0;
}

export function logError(error, extra = {}, level = 'error') {
  const entry = {
    time: new Date().toISOString(),
    message: error?.message || String(error),
    name: error?.name || 'Error',
    stack: error?.stack || null,
    level,
    sessionId: SESSION_ID,
    source: 'admin',
    extra
  };
  const signature = entry.name + '|' + entry.message + '|' + (entry.stack ? entry.stack.split('\n')[0] : '');
  if (shouldSample(signature)) {
    STATE.logs.push(entry);
    if (STATE.logs.length > MAX_LOGS) STATE.logs.shift();
    persist();
    enqueueForRemote(entry);
  }
  return entry;
}

export function logWarn(message, extra = {}) {
  return logError(message, extra, 'warn');
}

export function getErrorLogs() { return [...STATE.logs].reverse(); }
export function clearErrorLogs() { STATE.logs = []; persist(); }
export function flushErrorLogs() { flushQueue(); }

if (typeof window !== 'undefined') {
  window.__ADMIN_ERRORS__ = { getErrorLogs, clearErrorLogs };
}
